import { addMonths } from 'date-fns'

/**
 * Store related to any metadata about the offer request,
 * everything that is not already stored in the garden properties
 */
export const useRequestMetaStore = defineStore('requestMeta', () => {
  const options = useOptions()

  const uuid = ref<string | undefined>(options.meta.uuid ?? undefined)
  const publicUuid = ref<string | undefined>(options.meta.publicUuid ?? undefined)
  const permalink = ref<string | undefined>(options.meta.permalink ?? undefined)
  const publicPermalink = ref<string | undefined>(options.meta.publicPermalink ?? undefined)
  const finalized = ref(options.meta.finalized ?? false)
  const finalizedDate = ref<Date | undefined>(
    options.meta.finalizedDatetime ? new Date(options.meta.finalizedDatetime) : undefined,
  )
  const paid = ref(options.meta.paid ?? false)

  return {
    uuid,
    publicUuid,
    permalink,
    publicPermalink,
    finalized,
    finalizedDate,
    paid,
  }
})
